export let searchResults = "_xE1I";
export let searchResultsFromArchive = "mDPKcc";
export default {searchResults,searchResultsFromArchive};